export class EnsureNotNanValueConverter {

    /**
     * if the viewmodel value is NaN, display as replcementText in the GUI (not in the viewmodel!)
     * @param value
     * @param enabled turn on/off the conversion
     * @param replacementText
     */
    toView(value: number, enabled: boolean = true, replacementText: string = "[???]"): any {

        if (enabled && Number.isNaN(value)) return replacementText;
        else return value;
    }
}